export default __webpack_public_path__ + "static/media/PowerPoleWall_MK2.256.2c2dc5bb.png";